import { API_BASE_URL } from '../../api/api';

export const ProductList = ({
    loadingProducts,
    productsByUser,
    isSelected,
    toggleProduct,
    formatPrice
}) => {
    if (loadingProducts) {
        return <p className="text-center" style={{ color: '#8A91AE', fontSize: 12.5 }}>Cargando productos...</p>;
    }

    if (productsByUser.length === 0) {
        return (
            <div className="ui-table__empty">
                <i className="ri-inbox-line" />
                <span>No hay productos para este usuario.</span>
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
            {productsByUser.map((product) => {
                const selected = isSelected(product.id);
                const image = product.images?.[product.mainImage || 0];
                const imageUrl = image ? `${API_BASE_URL}/product/get/file/${image}` : null;
                const points = product.aditionalData?.[0]?.loyalty_points ?? 0;

                return (
                    <div className="ui-product-row" key={product.id} style={{ border: '1px solid #EDEFF6', borderRadius: 11, padding: '11px 13px' }}>
                        {imageUrl ? (
                            <img className="ui-product-row__thumb" src={imageUrl} alt={product.title} style={{ width: 44, height: 44, borderRadius: 8 }} />
                        ) : (
                            <div style={{ width: 44, height: 44, borderRadius: 8, background: '#F2F4FA', flexShrink: 0 }} />
                        )}
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 13.5, fontWeight: 700 }}>{product.title}</div>
                            <div className="ui-product-row__sku">SKU {product.id?.slice(-8)} · {points} pts</div>
                        </div>
                        <div style={{ fontSize: 14, fontWeight: 700, whiteSpace: 'nowrap' }}>
                            {formatPrice(product.aditionalData?.[0]?.price_local_currency)}
                        </div>
                        <button
                            type="button"
                            disabled={selected}
                            onClick={() => !selected && toggleProduct(product.id, true)}
                            style={{
                                border: 'none',
                                borderRadius: 8,
                                padding: '7px 12px',
                                fontFamily: 'inherit',
                                fontSize: 12,
                                fontWeight: 700,
                                cursor: selected ? 'default' : 'pointer',
                                background: selected ? '#F0FBF4' : '#4B36F0',
                                color: selected ? '#0F9A5A' : '#fff',
                                flexShrink: 0,
                            }}
                        >
                            {selected ? 'Agregado' : 'Agregar'}
                        </button>
                    </div>
                );
            })}
        </div>
    );
};
